import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MatTooltip } from '@angular/material/tooltip';
import { DatePipe, LowerCasePipe, NgTemplateOutlet } from '@angular/common';

import { CurrencyCasePipe } from '~/core/helpers/currency-case-pipe/currency-case-pipe';
import { ResponsiveClassDirective } from '~/core/directives/responsive-class.directive';
import { CloseButtonComponent } from '~/components/close-button/close-button.component';

@Component({
  selector: 'app-promotion-bonus-topbar-plus2',
  templateUrl: './promotion-bonus-topbar-plus2.component.html',
  styleUrls: ['./promotion-bonus-topbar-plus2.component.scss'],
  imports: [
    CurrencyCasePipe,
    TranslatePipe,
    MatTooltip,
    ResponsiveClassDirective,
    NgTemplateOutlet,
    LowerCasePipe,
    DatePipe,
    CloseButtonComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromotionBonusTopbarPlus2Component implements OnChanges {
  protected translate = inject(TranslateService);
  protected cdr = inject(ChangeDetectorRef);

  @Input() bonusAmount: number = 0;
  @Input() visible: boolean = true;
  @Input() context: string = '';
  @Input() bonusType: string = '';
  @Input() game: any = null;
  @Output() closeDialog = new EventEmitter<void>();
  @Output() claim = new EventEmitter<void>();

  @Input() promotionBonusScenario = 'MIXED';
  @Input() totalRounds = 0;
  @Input() mustClaim: boolean;
  @Input() totalBonuses: number;
  freeBetDescription: string;
  @Input() promotion: any;

  betUntil: string;

  constructor() {}

  ngOnChanges() {
    this.updateFreeBetDescription();
  }

  onClose() {
    this.closeDialog.emit();
  }

  onClaim() {
    this.claim.emit();
  }

  get animationState() {
    return this.visible ? 'visible' : 'hidden';
  }

  get isCasinoScenario() {
    return this.promotionBonusScenario === 'SINGLE_CASINO' || this.promotionBonusScenario === 'MULTIPLE_CASINO';
  }

  get isSingleCasinoGame() {
    return this.promotionBonusScenario === 'SINGLE_CASINO';
  }

  get isMixedScenario() {
    return this.promotionBonusScenario === 'MIXED';
  }

  get isMultiFreeBetScenario() {
    return this.promotionBonusScenario === 'MULTIPLE_FREE_BETS';
  }

  get isSportsbookScenario() {
    return this.promotionBonusScenario === 'SINGLE_SPORTSBOOK' || this.promotionBonusScenario === 'MULTIPLE_SPORTSBOOK';
  }

  get isAnyGameFreeBetScenario() {
    return this.promotionBonusScenario === 'ANY_GAME_FREE_BET';
  }

  get isSpecificGamesScenario() {
    return ['INCLUDING_ALL_MULTI_FREE_BET', 'INCLUDING_ONE_FREE_BET', 'EXCLUDING_ALL_FREE_BET'].includes(this.promotionBonusScenario);
  }

  get isSingleAltenarScenario() {
    return this.promotionBonusScenario === 'SINGLE_ALTENAR';
  }

  get isSingleBetbyScenario() {
    return this.promotionBonusScenario === 'SINGLE_BETBY';
  }

  get isSingleDigitainScenario() {
    return this.promotionBonusScenario === 'SINGLE_DIGITAIN';
  }

  get isSingleFreeBetScenario() {
    return this.promotionBonusScenario === 'SINGLE_SPORTSBOOK' && this.bonusType === 'FREE_BET';
  }

  get isGeneralScenario() {
    return this.promotionBonusScenario === 'SINGLE_GENERAL' || this.promotionBonusScenario === 'MULTIPLE_GENERAL';
  }

  /** For a single free bet, use its own title instead of the generic "FREE_BET!" label. */
  get freeBetTitle(): string | null {
    return this.totalBonuses === 1 ? this.promotion?.promotion?.friendly_name || null : null;
  }

  updateFreeBetDescription() {
    this.freeBetDescription = '';
    if (this.isSpecificGamesScenario || (this.isSingleAltenarScenario && !this.game?.name?.length)) {
      this.freeBetDescription = `FREE_BETS.EXCLUSIVE_FOR_SOME_EVENTS`;
      this.betUntil = this.promotion?.promotion?.config?.bet_until;
    } else if (this.isSingleAltenarScenario && this.game) {
      this.freeBetDescription = this.game?.name || '';
      this.betUntil = this.promotion?.promotion?.config?.bet_until;
    } else if (this.isSingleBetbyScenario) {
      this.freeBetDescription = this.promotion?.promotion?.friendly_name || '';
      this.betUntil = this.promotion?.promotion?.end_date;
    } else if (this.isSingleFreeBetScenario) {
      let language = this.translate.currentLang.replace('-', '_');
      this.freeBetDescription = `${this.game?.['home_competitor']?.[language]} x ${this.game?.['away_competitor']?.[language]}`;
      this.betUntil = this.promotion?.promotion?.config?.bet_until;
    } else if (this.isAnyGameFreeBetScenario) {
      this.freeBetDescription = `FREE_BETS.BET_AND_ENJOY`;
      this.betUntil = this.promotion?.promotion?.config?.bet_until;
    }
    this.cdr.markForCheck();
  }
}
